import React from 'react'
import { RouteProps } from 'react-router-dom'

import ConfirmationTemplate from '../../../templates/Confirmation'
import { useConfirmationTemplateProps } from '../../../templates/Confirmation/useProps'

const ConfirmationPage: React.FC<RouteProps> = () => {
  const templateProps = useConfirmationTemplateProps()

  return <ConfirmationTemplate {...templateProps} />
}

export default ConfirmationPage
